<template>
    <div :class="{'ly-is-full':isFull}">
        <div class="tableSelect" ref="tableSelect">
            <el-form :model="formInline">
                <el-form-item label="姓名：">
                    <el-input v-model="formInline.name" maxlength="100"  clearable placeholder="请输入姓名" @change="search" style="width:200px"></el-input>
                </el-form-item>
                <el-form-item label="生日：">
                    <el-date-picker style="width:350px" v-model="birthdayTimers" type="daterange" @change="birthdayTimeChange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="创建时间：" v-if="false">
                    <el-date-picker
                        style="width:350px"
                        v-model="timers"
                        type="datetimerange"
                        @change="timeChange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="" v-if="hasPermission(route.name,'Search')"><el-button @click="search" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item label=""><el-button @click="handleEdit('','reset')" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item label="" v-if="hasPermission(route.name,'Create')"><el-button type="primary" icon="Plus" @click="handleEdit('','add')" >新增</el-button></el-form-item>
                <el-form-item label="" v-if="hasPermission(route.name,'Delete') && true"><el-button @click="handleDelete" type="danger" :disabled="multiple" icon="Delete" >删除</el-button></el-form-item>
                <el-form-item label="" v-if="hasPermission(route.name,'Export') && true"><el-button type="primary" @click="exportDataBackend" :disabled="loadingPage" icon="Download">导出</el-button></el-form-item>
            </el-form>
        </div>
        <div class="table">
            <ly-table tableName="lyFormBuilderteacherManageTable" :height="tableHeight+51" :pageSize="10" :apiObj="lyformbuilderList" :params="formInline" ref="tableref" :column="column" showSelectable showSequence @selection-change="handleSelectionChange">
                <template #avatar="scope">
                    <el-image preview-teleported :src="scope.row.avatar" style="width: 30px;height:30px" :preview-src-list="[scope.row.avatar]" v-if="scope.row.avatar"></el-image>
                </template>
                <template #subject="scope">
                    <span v-for="(item,index) in [{'label': '语文', 'value': '语文'}, {'label': '英语', 'value': '英语'}, {'value': '数学', 'label': '数学'}, {'value': '体育', 'label': '体育'}, {'value': '生物', 'label': '生物'}, {'value': '化学', 'label': '化学'}, {'value': '音乐', 'label': '音乐'}, {'value': '美术', 'label': '美术'}, {'value': '历史', 'label': '历史'}]">
                        <span  v-if="scope.row.subject == item.value" >{{ item.label }}</span>
                    </span>
                </template>
                <template #gender="scope">
                    <span v-for="(item,index) in [{'label': '未知', 'value': '0'}, {'label': '男', 'value': '1'}, {'label': '女', 'value': '2'}]">
                        <span  v-if="scope.row.gender == item.value" >{{ item.label }}</span>
                    </span>
                </template>
                <template #workstatus="scope">
                    <el-tag v-if="scope.row.workstatus">在职</el-tag>
<el-tag v-else type="danger">离职</el-tag>
                </template>
                <template #students="scope">
                    <span>{{scope.row.students.length+"个"}}</span>
                </template>
                <el-table-column label="操作" fixed="right" width="180">
                    <template #header>
                        <div style="display: flex;justify-content: space-between;align-items: center;">
                            <div>操作</div>
                            <div @click="setFull">
                                <el-tooltip content="全屏" placement="bottom">
                                    <el-icon ><full-screen /></el-icon>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                    <template #default="scope">
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'detail')" v-show="hasPermission(route.name,'Retrieve')">详情</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'edit')" v-if="hasPermission(route.name,'Update')">编辑</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row,'delete')" v-if="hasPermission(route.name,'Delete')">删除</span>
                    </template>
                </el-table-column>
            </ly-table>
        </div>
        <lyDialog v-model="dialogVisible" v-if="dialogVisible" :title="dialogTitleMap[currentMode]" width="60%" :before-close="handleClose" :fullscreen="fullscreen" :loading="dialogLoading">
            <lyFormRender :form-json="formJson" :form-data="formData" ref="lyFormBuilderRef"></lyFormRender>
            <template #footer>
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="loadingSave" v-if="currentMode!='detail'">确定</el-button>
            </template>
        </lyDialog>
    </div>
</template>

<script setup>

    import {ajaxGet,ajaxPost,ajaxDelete,ajaxPut,ajaxPatch,ajaxDownloadExcel} from '@/api/request'
    // 列表
    const lyformbuilderList = params => ajaxGet({url: `lyformbuilder/teacherManage/`,params})
    // 新增
    const lyformbuilderAdd = params => ajaxPost({url: `lyformbuilder/teacherManage/`,params})
    // 编辑
    const lyformbuilderEdit = params => ajaxPut({url: `lyformbuilder/teacherManage/`,params})
    // 删除
    const lyformbuilderDelete = params => ajaxDelete({url: `lyformbuilder/teacherManage/`,params})
    // 导出
    const lyformbuilderExport = params => ajaxDownloadExcel({url: `lyformbuilder/teacherManage/export/`,params})
    const studentsLyFormBuilderAPI = params => ajaxGet({url: `autocode/StudentManage/`,params})
    
    import {ref,reactive,onMounted,onBeforeUnmount,nextTick} from 'vue'
    import { ElMessage,ElMessageBox } from 'element-plus';
    import {hasPermission,dateFormats,getStorage,deepClone} from "@/utils/util";
    import LyDialog from "@/components/dialog/dialog";
    import useTableHight from '@/mixins/useTableHight';
    import lyFormRender from '@/components/lyform-builder/lyform-render/index'
    import { useRoute } from 'vue-router'

    const route = useRoute()

    let isFull = ref(false)
    let orderStatic = ref(null)
    let tableSelect = ref(null)
    let tableHeight = useTableHight(orderStatic,tableSelect,isFull.value)
    let loadingPage = ref(false)
    let formInline = ref({})

    let defaultImg = ref(require('../../assets/img/avatar.jpg'))
    let tableData = ref([])
    let timers = ref([])
    let birthdayTimers = ref([])
    
    let column = ref([
        {
            label: "头像",
            prop: "avatar",
            minWidth:"100",
            hide: !true
        },
        {
            label: "姓名",
            prop: "name",
            minWidth:"100",
            hide: !true
        },
        {
            label: "手机号",
            prop: "phone",
            minWidth:"100",
            hide: !true
        },
        {
            label: "科目",
            prop: "subject",
            minWidth:"100",
            hide: !true
        },
        {
            label: "性别",
            prop: "gender",
            minWidth:"100",
            hide: !true
        },
        {
            label: "生日",
            prop: "birthday",
            minWidth:"100",
            hide: !true
        },
        {
            label: "在职状态",
            prop: "workstatus",
            minWidth:"100",
            hide: !true
        },
        {
            label: "关联学生",
            prop: "students",
            minWidth:"100",
            hide: !true
        },
        {
            label: "创建时间",
            prop: "create_datetime",
            minWidth:"180"
        }
    ])

    // 选项框选中数组
    let ids = ref([])
    // 选项框非单个禁用
    let single = ref(true)
    // 非多个禁用
    let multiple = ref(true)

    let tableref = ref(null)

    //多选项框被选中数据
    function handleSelectionChange(selection) {
        ids.value = selection.map(item => item.id);
        single.value = selection.length !== 1;
        multiple.value = !selection.length;
    }

    function isobject(item){
        if(typeof(item) == "object"){
            return true
        }else{
            return false
        }
    }
    function setFull(){
        isFull.value=!isFull.value
        window.dispatchEvent(new Event('resize'))
    }
    function setLoadingPage(bools){
        loadingPage.value = bools
        tableref.value.loadingPage(bools)
    }
    function convertStrNum(model,value){
        if(model === "" || model === null || model === undefined){
            return value
        }
        else if(Object.prototype.toString.call(model)=== "[object String]"){
            return value.toString()
        }
        else if(Object.prototype.toString.call(model) === "[object Number]"){
            return value*1
        }else{
            return value
        }
    }
    function search() {
        tableref.value.reload(formInline.value)
    }

    /** 批量删除按钮操作 */
    function handleDelete(row) {
        ElMessageBox.confirm('是否确认删除选中的数据项?', "警告", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(function() {
            return lyformbuilderDelete({id:ids.value}).then(res=>{
                if(res.code == 2000) {
                    ElMessage.success(res.msg)
                    getData()
                } else {
                    ElMessage.warning(res.msg)
                }
            })
        })
    }
    
    let studentsLyFormBuilderAPIList = ref([])
    
    function studentsLyFormBuilderAPIFunction() {
        studentsLyFormBuilderAPI({page:1,limit:999}).then(res => {
            if(res.code ==2000) {
                studentsLyFormBuilderAPIList.value = res.data.data
            }
            lyFormBuilderRef.value.setFormJsonSelectOption('students',studentsLyFormBuilderAPIList.value)
        })
    }
    function handleEdit(row,flag) {
        if(flag=='add') {
            currentMode.value = 'add';
            disableForm(false)
            dialogVisible.value=true
            studentsLyFormBuilderAPIFunction()
        }
        else if(flag=='edit') {
            currentMode.value = 'edit';
            disableForm(false)
            formData.value = deepClone(row)
            dialogVisible.value=true
            studentsLyFormBuilderAPIFunction()
        }
        else if(flag=='detail') {
            currentMode.value = 'detail';
            if(currentMode.value == "detail"){
                disableForm()
            }
            formData.value = deepClone(row)
            dialogVisible.value=true
            studentsLyFormBuilderAPIFunction()
        }
        else if(flag=='delete') {
            ElMessageBox.confirm('您确定要删除选中的数据吗？', "警告",{
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function() {
                return  lyformbuilderDelete({id:row.id}).then(res=>{
                    if(res.code == 2000) {
                        ElMessage.success(res.msg)
                        getData()
                    } else {
                        ElMessage.warning(res.msg)
                    }
                })
            })
        }
        else if(flag=="reset"){
            formInline.value = {}
            timers.value = []
            birthdayTimers.value=[]
            search()
        }
    }
    //获取列表
    async function getData(){
        tableref.value.getData()
    }
    function timeChange(val){
        if (val) {
            formInline.value.beginAt=dateFormats(val[0],'yyyy-MM-dd hh:mm:ss');
            formInline.value.endAt=dateFormats(val[1],'yyyy-MM-dd hh:mm:ss');
        } else {
            formInline.value.beginAt = null
            formInline.value.endAt = null
        }
        search()
    }
    function birthdayTimeChange(val) {
        if (val) {
            formInline.value.birthday_beginAt=dateFormats(val[0],'yyyy-MM-dd');
            formInline.value.birthday_endAt=dateFormats(val[1],'yyyy-MM-dd');
        } else {
            formInline.value.birthday_beginAt = null
            formInline.value.birthday_endAt = null
        }
        search()
    }
    //弹窗
    let dialogVisible = ref(false)
    let dialogLoading = ref(false)
    let loadingSave = ref(false)
    let dialogTitle = ref('')
    let currentMode = ref('add')
    let dialogTitleMap = {
        add: '新增',
        edit: '编辑',
        detail: '详情'
    }

    let fullscreen = ref(false)
    let formJson = ref({"widgetList": [{"key": 40911, "type": "picture-single", "icon": "Picture", "formItemFlag": true, "displayName": "\u5355\u56fe\u4e0a\u4f20", "options": {"name": "avatar", "isFormField": true, "crudField": {"field_name": "avatar", "verbose_name": "\u5934\u50cf", "field_type": "CharField", "foreign_key": {"class_name": "", "on_delete": "", "label": "", "value": "id", "api_path": ""}, "max_length": "100", "default": null, "db_index": false, "nullable": true, "unique": false, "can_edit": true, "edit_disabled": false, "can_list": true, "can_search": false, "search_type": "", "can_export": false, "width": 100, "list_display_custom": ""}, "label": "\u5934\u50cf", "labelAlign": "", "labelWidth": null, "labelHidden": false, "columnWidth": "200px", "disabled": false, "hidden": false, "required": false, "requiredHint": "", "customRule": "", "customRuleHint": "", "uploadURL": "", "uploadTitle": "", "uploadIcon": "plus", "uploadWidth": 148, "uploadHight": 148, "showFileList": true, "fileMaxSize": 5, "fileTypes": ["jpg", "jpeg", "png"], "round": true, "cropper": true, "compress": 1, "aspectRatio": null, "customClass": [], "onSuccess": ""}, "id": "picturesingle93718"}, {"key": 68543, "type": "input", "icon": "lyicon-text-field", "formItemFlag": true, "displayName": "\u5355\u884c\u8f93\u5165", "options": {"name": "name", "isFormField": true, "crudField": {"field_name": "name", "verbose_name": "\u59d3\u540d", "field_type": "CharField", "foreign_key": {"class_name": "", "on_delete": "", "label": "", "value": "id", "api_path": ""}, "max_length": "50", "default": null, "db_index": false, "nullable": true, "unique": false, "can_edit": true, "edit_disabled": false, "can_list": true, "can_search": true, "search_type": "icontains", "can_export": true, "width": 100, "list_display_custom": ""}, "label": "\u59d3\u540d", "labelAlign": "", "type": "text", "defaultValue": "", "placeholder": "", "columnWidth": "200px", "size": "", "labelWidth": null, "labelHidden": false, "readonly": false, "disabled": false, "hidden": false, "clearable": true, "showPassword": false, "required": true, "requiredHint": "", "validation": "", "validationHint": "", "customClass": [], "minLength": null, "maxLength": null, "showWordLimit": false, "prefixIcon": "", "suffixIcon": "", "prependSlot": "", "appendSlot": "", "onInput": "", "onChange": "", "onFocus": "", "onBlur": ""}, "id": "input89681"}, {"key": 23796, "type": "input", "icon": "lyicon-text-field", "formItemFlag": true, "displayName": "\u5355\u884c\u8f93\u5165", "options": {"name": "phone", "isFormField": true, "crudField": {"field_name": "phone", "verbose_name": "\u624b\u673a\u53f7", "field_type": "CharField", "foreign_key": {"class_name": "", "on_delete": "", "label": "", "value": "id", "api_path": ""}, "max_length": "100", "default": null, "db_index": false, "nullable": true, "unique": false, "can_edit": true, "edit_disabled": false, "can_list": true, "can_search": false, "search_type": "", "can_export": true, "width": 100, "list_display_custom": ""}, "label": "\u624b\u673a\u53f7", "labelAlign": "", "type": "text", "defaultValue": "", "placeholder": "", "columnWidth": "200px", "size": "", "labelWidth": null, "labelHidden": false, "readonly": false, "disabled": false, "hidden": false, "clearable": true, "showPassword": false, "required": true, "requiredHint": "\u624b\u673a\u53f7\u4e0d\u80fd\u4e3a\u7a7a", "validation": "mobilePhone", "validationHint": "\u8bf7\u8f93\u5165\u6b63\u786e\u624b\u673a\u53f7", "customClass": [], "minLength": null, "maxLength": null, "showWordLimit": false, "prefixIcon": "", "suffixIcon": "", "prependSlot": "", "appendSlot": "", "onInput": "", "onChange": "", "onFocus": "", "onBlur": ""}, "id": "input94278"}, {"key": 86542, "type": "select", "icon": "lyicon-select-field", "formItemFlag": true, "displayName": "\u4e0b\u62c9\u9009\u62e9\u6846", "options": {"name": "subject", "isFormField": true, "crudField": {"field_name": "subject", "verbose_name": "\u79d1\u76ee", "field_type": "CharField", "foreign_key": {"class_name": "", "on_delete": "", "label": "", "value": "id", "api_path": ""}, "max_length": "50", "default": null, "db_index": false, "nullable": true, "unique": false, "can_edit": true, "edit_disabled": false, "can_list": true, "can_search": false, "search_type": "", "can_export": false, "width": 100, "list_display_custom": ""}, "label": "\u79d1\u76ee", "labelAlign": "", "defaultValue": "", "placeholder": "", "columnWidth": "200px", "size": "", "labelWidth": null, "labelHidden": false, "disabled": false, "hidden": false, "clearable": true, "filterable": false, "allowCreate": false, "remote": false, "automaticDropdown": false, "multiple": false, "multipleLimit": 0, "optionItems": [{"label": "\u8bed\u6587", "value": "\u8bed\u6587"}, {"label": "\u82f1\u8bed", "value": "\u82f1\u8bed"}, {"value": "\u6570\u5b66", "label": "\u6570\u5b66"}, {"value": "\u4f53\u80b2", "label": "\u4f53\u80b2"}, {"value": "\u751f\u7269", "label": "\u751f\u7269"}, {"value": "\u5316\u5b66", "label": "\u5316\u5b66"}, {"value": "\u97f3\u4e50", "label": "\u97f3\u4e50"}, {"value": "\u7f8e\u672f", "label": "\u7f8e\u672f"}, {"value": "\u5386\u53f2", "label": "\u5386\u53f2"}], "required": false, "requiredHint": "", "validation": "", "validationHint": "", "customClass": [], "onRemoteMethod": "", "onRemoveTag": "", "onChange": "", "onFocus": "", "onBlur": "", "useForeignData": false}, "id": "select59342"}, {"key": 89556, "type": "radio", "icon": "lyicon-radio-field", "formItemFlag": true, "displayName": "\u5355\u9009\u6846\u7ec4", "options": {"name": "gender", "isFormField": true, "crudField": {"field_name": "gender", "verbose_name": "\u6027\u522b", "field_type": "IntegerField", "foreign_key": {"class_name": "", "on_delete": "", "label": "", "value": "id", "api_path": ""}, "max_length": "100", "default": 0, "db_index": false, "nullable": true, "unique": false, "can_edit": true, "edit_disabled": false, "can_list": true, "can_search": false, "search_type": "", "can_export": false, "width": 100, "list_display_custom": ""}, "label": "\u6027\u522b", "labelAlign": "", "defaultValue": "0", "columnWidth": "200px", "size": "", "displayStyle": "inline", "buttonStyle": false, "border": true, "labelWidth": null, "labelHidden": false, "disabled": false, "hidden": false, "optionItems": [{"label": "\u672a\u77e5", "value": "0"}, {"label": "\u7537", "value": "1"}, {"label": "\u5973", "value": "2"}], "required": false, "requiredHint": "", "validation": "", "validationHint": "", "customClass": [], "onChange": ""}, "id": "radio102904"}, {"key": 94224, "type": "date", "icon": "lyicon-date-field", "formItemFlag": true, "displayName": "\u65e5\u671f", "options": {"name": "birthday", "isFormField": true, "crudField": {"field_name": "birthday", "verbose_name": "\u751f\u65e5", "field_type": "DateField", "foreign_key": {"class_name": "", "on_delete": "", "label": "", "value": "id", "api_path": ""}, "max_length": "100", "default": null, "db_index": false, "nullable": true, "unique": false, "can_edit": true, "edit_disabled": false, "can_list": true, "list_display_custom": "", "can_search": true, "search_type": "range", "can_export": false, "width": 100}, "label": "\u751f\u65e5", "labelAlign": "", "type": "date", "defaultValue": null, "placeholder": "", "columnWidth": "200px", "size": "", "autoFullWidth": true, "labelWidth": null, "labelHidden": false, "readonly": false, "disabled": false, "hidden": false, "clearable": true, "editable": false, "format": "YYYY-MM-DD", "valueFormat": "YYYY-MM-DD", "required": false, "requiredHint": "", "validation": "", "validationHint": "", "customClass": [], "onChange": "", "onFocus": "", "onBlur": ""}, "id": "date55524"}, {"key": 98671, "type": "switch", "icon": "open", "formItemFlag": true, "displayName": "\u5f00\u5173", "options": {"name": "workstatus", "isFormField": true, "crudField": {"field_name": "workstatus", "verbose_name": "\u5728\u804c\u72b6\u6001", "field_type": "BooleanField", "foreign_key": {"class_name": "", "on_delete": "", "label": "", "value": "id", "api_path": ""}, "max_length": "100", "default": true, "db_index": false, "nullable": true, "unique": false, "can_edit": true, "edit_disabled": false, "can_list": true, "can_search": false, "search_type": "", "can_export": false, "width": 100, "list_display_custom": "<el-tag v-if=\"scope.row.workstatus\">\u5728\u804c</el-tag>\n<el-tag v-else type=\"danger\">\u79bb\u804c</el-tag>"}, "label": "\u5728\u804c\u72b6\u6001", "labelAlign": "", "defaultValue": true, "columnWidth": "200px", "size": "", "labelWidth": null, "labelHidden": false, "disabled": false, "hidden": false, "customClass": [], "inlinePrompt": false, "switchWidth": 40, "activeText": "\u5728\u804c", "inactiveText": "\u79bb\u804c", "activeColor": null, "inactiveColor": null, "onChange": ""}, "id": "switch49990"}, {"key": 76190, "type": "select", "icon": "lyicon-select-field", "formItemFlag": true, "displayName": "\u4e0b\u62c9\u9009\u62e9\u6846", "options": {"name": "students", "isFormField": true, "crudField": {"field_name": "students", "verbose_name": "\u5173\u8054\u5b66\u751f", "field_type": "ManyToManyField", "foreign_key": {"class_name": "StudentManage", "on_delete": "PROTECT", "label": "name", "value": "id", "api_path": "autocode/StudentManage/"}, "max_length": "100", "default": [], "db_index": false, "nullable": true, "unique": false, "can_edit": true, "edit_disabled": false, "can_list": true, "list_display_custom": "<span>{{scope.row.students.length+\"\u4e2a\"}}</span>", "can_search": false, "search_type": "", "can_export": false, "width": 100}, "label": "\u5173\u8054\u5b66\u751f", "labelAlign": "", "defaultValue": [], "placeholder": "", "columnWidth": "200px", "size": "", "labelWidth": null, "labelHidden": false, "disabled": false, "hidden": false, "clearable": true, "filterable": false, "allowCreate": false, "remote": false, "automaticDropdown": false, "multiple": true, "multipleLimit": 0, "optionItems": [], "required": false, "requiredHint": "", "validation": "", "validationHint": "", "customClass": [], "onRemoteMethod": "", "onRemoveTag": "", "onChange": "", "onFocus": "", "onBlur": "", "useForeignData": true}, "id": "select101805"}], "formConfig": {"modelName": "formData", "refName": "lyFormBuilder", "rulesName": "rules", "modelDbTable": "tb_teachermanage", "modelClassName": "teacherManage", "modelVerboseName": "\u8001\u5e08\u7ba1\u7406", "other_config": {"create_datetime_filter": false, "mutiple_delete": true}, "labelWidth": "auto", "labelPosition": "right", "size": "", "disabled": false, "cssCode": "", "customClass": "", "functions": "", "jsonVersion": 1, "onFormMounted": ""}, "class_name": "teacherManage", "file_name_old": "teacherManage"})
    let formData = ref({})
    let lyFormBuilderRef = ref(null)

    function handleClose() {
        dialogVisible.value = false
        dialogLoading.value = false
        loadingSave.value = false
        currentMode.value = 'add'
        formData.value = {}
    }

    function disableForm(flag=true){
        if(formJson.value.formConfig){
            formJson.value.formConfig.disabled = flag
        }
    }

    //excel文件流下载
    function downloadExcelBlob(res) {
        let fileName = new Date().getTime() +".xlsx"
        let dispositionStr = res.headers["content-disposition"];
        if (dispositionStr == null || dispositionStr === "") {

        }else{
            // 获取文件名
            let dispositionArr = dispositionStr.split(";");
            fileName = decodeURIComponent(dispositionArr[1]);
            fileName = fileName.split("=")[1];
        }
        const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let href = window.URL.createObjectURL(blob); //下载链接
        let link = document.createElement("a")
        link.href = href
        link.download = fileName //下载后文件名
        document.body.appendChild(link);
        link.click(); //点击下载
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(href);  //释放blob对象
        ElMessage.success('导出成功')
    }
    //导出
    function exportDataBackend() {
        let params = {}
        if(ids.value.length>0){
            params = {
                ids:ids.value,
            }
        }
        setLoadingPage(true)
        lyformbuilderExport(params).then(res => {
            setLoadingPage(false)
            downloadExcelBlob(res)
        })
    }

    const submitForm = () => {
        lyFormBuilderRef.value.getFormData().then(formData => {
            if(formData){
                loadingSave.value=true
                let param = {
                    ...formData
                }
                if(currentMode.value == 'add'){
                    lyformbuilderAdd(param).then(res=>{
                        loadingSave.value=false
                        if(res.code ==2000) {
                            ElMessage.success(res.msg)
                            handleClose()
                            getData()
                        } else {
                            ElMessage.warning(res.msg)
                        }
                    })
                }else{
                    lyformbuilderEdit(param).then(res=>{
                        loadingSave.value=false
                        if(res.code ==2000) {
                            ElMessage.success(res.msg)
                            handleClose()
                            getData()
                        } else {
                            ElMessage.warning(res.msg)
                        }
                    })
                }
            }
                
        }).catch(error => {
                ElMessage.error(error)
        })
    }

    defineExpose({
        setFull
    })

    
</script>

<style lang="scss" scoped>

</style>
